import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import ContactSearch from './ContactSearchContainer';
import ContactStyles from './ContactStyles.scss';
import ContactFields from './ContactFields';
import { Button, Divider } from 'semantic-ui-react';
import PhoneUtils from '../../../lib/utils/phone';
import { FloatingLabelInput } from '../../Elements';
import {
  Analytics,
  DthcActions,
  GlobalNotifications,
  Intent
} from '../../Modules';
import Formsy from 'formsy-react';

export default class NewContactDesktop extends React.Component {
  static propTypes = {
    reset: PropTypes.func.isRequired,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    deleteUserContactEmail: PropTypes.func,
    deleteUserContactPhone: PropTypes.func,
    deleteUserContactAddress: PropTypes.func,
    delete: PropTypes.func,
    commitUpdate: PropTypes.func,
    onChange: PropTypes.func,
    contact: PropTypes.object,
    localContact: PropTypes.object,
    index: PropTypes.number,
    closeHandler: PropTypes.func,
    event: PropTypes.object.isRequired,
    refetchEvent: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      step: 'initial',
      role: '',
      contact: {}
    };
    this.goToStep = this.goToStep.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.onRoleChange = this.onRoleChange.bind(this);
    this.createUserContactEvent = this.createUserContactEvent.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
  }

  onInvalidSubmit() {
    GlobalNotifications.show({
      message: 'Unable to add contact',
      intent: Intent.DANGER
    });
  }

  onRoleChange(e) {
    this.setState({ role: e.target.value });
  }

  createUserContactEvent() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to add contact',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully added contact',
        intent: Intent.SUCCESS
      });
      this.props.reset();
      this.props.refetchEvent();
      Analytics.trackEvent('added-existing-contact');
    };

    const mutation = graphql`
      mutation NewContactDesktop_createUserContactEventMutation(
        $input: CreateUserContactEventInput!
      ) {
        createUserContactEvent(input: $input) {
          new_event_user_contact_edge {
            id
            role
            node {
              id
              first_name
              last_name
              user_contact_addresses {
                edges {
                  node {
                    id
                    label
                    line1
                    line2
                    city
                    province
                    postal_code
                    country
                  }
                }
              }
              user_contact_emails {
                edges {
                  node {
                    id
                    label
                    address
                  }
                }
              }
              user_contact_phones {
                edges {
                  node {
                    id
                    label
                    number
                  }
                }
              }
            }
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const parentID = this.props.event.id;

    const configs = [
      {
        type: 'RANGE_ADD',
        parentID,
        edgeName: 'new_event_user_contact_edge',
        connectionInfo: [
          {
            key: 'EventSummaryContainer_user_contacts',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          user_contact_id: this.state.contact.id,
          event_id: this.props.event.id,
          role: this.state.role
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  goToStep(step) {
    this.setState({ step });
  }

  handleResultSelect(data) {
    this.setState({ step: 'addExisting', contact: data.result });
  }

  render() {
    return (
      <div className={ContactStyles.active} style={{ padding: '1em' }}>
        <h3>Add Contact</h3>
        {this.state.step === 'initial' &&
          <div>
            <ContactSearch
              viewer={this.props.viewer}
              handleResultSelect={this.handleResultSelect}
            />
            <Divider horizontal>Or</Divider>
            <div style={{ textAlign: 'center' }}>
              <Button
                primary
                content='Create New Contact'
                icon='plus'
                labelPosition='left'
                onClick={this.goToStep.bind(null, 'new')}
              />
            </div>
            <div className={ContactStyles.cancel}>
              <a onClick={this.props.reset}>Cancel</a>
            </div>
          </div>}
        {this.state.step === 'new' &&
          <div style={{ padding: '1em 2em' }}>
            <ContactFields
              deleteUserContactEmail={this.props.deleteUserContactEmail}
              deleteUserContactPhone={this.props.deleteUserContactPhone}
              deleteUserContactAddress={this.props.deleteUserContactAddress}
              delete={this.props.delete}
              reset={this.props.reset}
              commitUpdate={this.props.commitUpdate}
              onChange={this.props.onChange}
              contact={this.props.contact}
              localContact={this.props.localContact}
              index={this.props.index}
              closeHandler={this.props.closeHandler}
            />
          </div>}
        {this.state.step === 'addExisting' &&
          <div>
            <blockquote style={{ fontSize: '1rem' }}>
              <strong>
                {this.state.contact.name}
              </strong>
              <div className={ContactStyles.description}>
                {PhoneUtils.formatPhoneNumber(this.state.contact.phone)}
              </div>
              <div className={ContactStyles.description}>
                <a
                  onClick={e => e.stopPropagation()}
                  href={`mailto:${this.state.contact.email}`}
                >
                  {this.state.contact.email}
                </a>
              </div>
            </blockquote>
            <br />
            <p>
              What is {this.state.contact.name}&apos;s role during this event?
            </p>
            <Formsy.Form onValidSubmit={this.createUserContactEvent} onInvalidSubmit={this.onInvalidSubmit}>
              <FloatingLabelInput
                label='Role'
                placeholder='Bride'
                type='text'
                name='role'
                fluid
                autoFocus
                value={this.state.role}
                onChange={this.onRoleChange}
                required
                validationError='Role is required'
              />
              <DthcActions
                reset={this.props.reset}
                id={this.state.contact.childKey}
              />
            </Formsy.Form>
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/NewContactDesktop.js